import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyByAep7iUYPj6TM-2Dyd3OdyGAit5wqd7I",
  authDomain: "alpha-trade-finance.firebaseapp.com",
  projectId: "alpha-trade-finance",
  storageBucket: "alpha-trade-finance.appspot.com",
  messagingSenderId: "265369055330",
  appId: "1:265369055330:web:783da6a1bc1f7b5f55213b",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyBGq25Hh0nt1zy-G4L32-hYypt6LDS9ULc",
//   authDomain: "finance-test-5f328.firebaseapp.com",
//   projectId: "finance-test-5f328",
//   storageBucket: "finance-test-5f328.appspot.com",
//   messagingSenderId: "261981000578",
//   appId: "1:261981000578:web:ee913ada0c961a2803759b",
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
